import React, { useEffect, useState } from "react";
import {
    TableHead,
    TableBody,
    Table,
    TableContainer,
    TableCell,
    TableRow,
    Box,
    TablePagination,
    Pagination,
    Button,
    TextField,
    Typography,
    InputAdornment,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    MenuItem,
    Menu,
} from "@mui/material";
import './LoanPaymentViewCancel.scss';
import SearchIcon from "@mui/icons-material/Search";
import { commonRunQuery, getListOfUserPayments, loanApprove, loanPaymentCancel, postAdjustmentNoPin10 } from "../../util/API/loans";

import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import CustomInputAlert from "../UI/CustomInputAlert/CustomInputAlert";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";
import LoanPaymentBreakdown from "../LoanPaymentBreakdown/LoanPaymentBreakdown";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import { getExternalAccounts } from "../../util/API/externalaccounts";
import { LOANS_ACCOUNT_NO } from "../../config";

const LoanPaymentViewCancel = ({
    setViewCancelPayments,
    selectedProductLoan,
    selectedUser,
    setAlert,
    setAlertOpen
}) => {
    const [searchText, setSearchText] = useState("");
    const [loanList, setLoanList] = useState([]);
    const [allLoans, setAllLoans] = useState([]);
    // const [showInputAlert, setShowInputAlert] = useState(false);
    const [showInputAlert, setShowInputAlert] = useState({
        showAlert: false,
        severity: "",
        header: "",
        message: "",
        onConfirm: null,
        alertType: "",
        inputLabel:""
      });
    const [selectedLoan, setSelectedLoan] = useState(null);
    const authUser = sessionStorage.getItem("user");
    const parsedAuthUser = JSON.parse(authUser);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openLoanDetailsDrawer, setOpenLoanDetailsDrawer] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [userTransactionAccArr, setUserTransactionAccArr] = useState([]);
    const [openDetailsDrawer, setOpenDetailsDrawer] = useState(false);

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
        // backgroundColor: "rgba(0,0,0, .1)",
        color: theme.palette.common.black,
        fontWeight: "bold",
        textAlign: "center",
        },
        [`&.${tableCellClasses.body}`]: {
        fontSize: 25,
        fontWeight: "600",
        },
    }));

    const handleInputChange = (e) => {
        setSearchText(e.target.value);
    }

    useEffect(()=> {
        getPaymentsList();
        getUserAccounts();
    },[selectedUser, selectedProductLoan]);

    const getUserAccounts = async() => {
        let response = await getExternalAccounts(selectedUser);
        console.log("getUserAccounts===============", response);
        let records = response.payload?.record;
        if (!records) return;
        if (!Array.isArray(records)) {
            records = [records];
        }
        // Separate transaction accounts from other accounts
        // const transactionAccounts = records.filter((account) =>
        //     account.Vuserpi3?.friendlyname?.toLowerCase().includes("transaction")
        // );

        const transactionAccounts = records.filter((account) => {
            const name = account.Vuserpi3?.friendlyname?.toLowerCase() || "";
            return name.includes("transaction") || name.includes("checking");
        });

        setUserTransactionAccArr(transactionAccounts);
        console.log("transactionAccounts===============", transactionAccounts[0]?.Vuserpi3);
    }

    const getPaymentsList = async() => {
        try {
            const response = await commonRunQuery(247, `${selectedUser}`);
            // const response = await getListOfUserPayments(235, `${selectedUser}/${selectedProductLoan?.productcode}`);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const loanPaymentsArray = Array.isArray(response?.data?.body?.record)
                ? response?.data?.body?.record
                : [response?.data?.body?.record];
                
                console.log("getPaymentsList_loanPaymentsArray=======================",loanPaymentsArray);
                setLoanList(loanPaymentsArray);
                setAllLoans(loanPaymentsArray);
            } else if(response?.data?.header?.reccount === "0") {
                setLoanList([]);
                setAllLoans([]);
            }
        } catch (error) {
            console.log("getPaymentsList_error=======================",error);
        }
    }

    // const handleLoanApproval = async(comment, rowData) => {
    //     try {
    //         const response = await loanApprove("", rowData?.loanrequests?.requestid, 1, parsedAuthUser?.userid, comment);
    //         if(response?.data?.header?.callStatus === "1" ) {
    //             getPaymentsList();
    //             setAlert({
    //                 showAlert: true,
    //                 severity: "success",
    //                 message: "Loan approved successfully.",
    //                 header: "Congratulations!",
    //             });
    //         }
    //     } catch (error) {
    //         console.log("handleLoanApproval_error=======================",error);
    //     }
    // }

    const handleLoanCancellation = async(reason, rowData) => {
        try {
            console.log("selectedLoan=======================",rowData);
            console.log("handleLoanCancellation=======================",reason);
            const response = await loanPaymentCancel("", rowData?.loanapplied?.userid, rowData?.loanapplied?.paymentid, "", "", reason, rowData?.loanapplied?.loanid, rowData?.loanapplied?.currcode, 0);
            console.log("handleLoanCancellation_response=======================",response);
            if(response?.data?.header?.callStatus === "1") {
                let transactions = [
                    {
                        accountnumber: LOANS_ACCOUNT_NO,
                        type: 1,  
                        amount: rowData?.loanapplied?.amountapplied,
                        transactiontype: 1,
                        negativebalanceallowed: 1,
                        positivebalanceallowed: 1,        
                    },
                    {
                        accountnumber: userTransactionAccArr[0]?.Vuserpi3?.acctID,
                        type: 2,
                        amount: rowData?.loanapplied?.amountapplied,
                        transactiontype: 1,
                        negativebalanceallowed: 1,
                        positivebalanceallowed: 0,     
                    }
                ];

                let reason = "Payment Cancelled";

                const response1 = await postAdjustmentNoPin10(
                    "", // location
                    0, // fromuserid
                    rowData?.loanapplied?.userid, // touserid
                    rowData?.loanapplied?.currcode, // currency
                    transactions, // transactions
                    reason, // reason
                    "", // externalrefid
                    0, // sourcepi
                    userTransactionAccArr[0]?.Vuserpi3?.piid, // targetpi
                    0, // sourceuserpi
                    userTransactionAccArr[0]?.Vuserpi3?.id, // targetuserpi
                    "", //clerkname
                    1, // transtypeid
                    userTransactionAccArr[0]?.Vuserpi3?.acctID, //recipientaccountno
                    "", // adminmsg
                    0, // channelid
                    selectedUser, //recipientuserid
                    0, //parentuserid
                );

                console.log("postAdjustmentNoPin10_response1---------------",response1);

                setAlert({
                    showAlert: true,
                    severity: "success",
                    message: "Loan payment cancelled successfully.",
                    header: "Congratulations!",
                });

                setAlertOpen(true);
                getPaymentsList();
            }
        } catch (error) {
            console.log("handleLoanCancellation_error=======================",error);
        }
    }

    // const approveLoanConfirmation = async(rowData) => {
    //     console.log("approveLoanConfirmation=======================",rowData);
    //     setSelectedLoan(rowData);
    //     setShowInputAlert((prevState) => ({
    //         ...prevState,
    //         showAlert: true,
    //         severity: "confirm",
    //         message: "Are you sure you want to approve this loan?",
    //         header: "Confirm Approval",
    //         alertType: "confirm",
    //         inputLabel: "Comment",
    //         onConfirm: (comment) => {
    //             handleLoanApproval(comment, rowData);
    //         },
    //     }));
    // }

    const cancelLoanConfirmation = async(rowData) => {
        setSelectedLoan(rowData);
        setShowInputAlert((prevState) => ({
            ...prevState,
            showAlert: true,
            severity: "confirm",
            message: "Are you sure you want to cancel this loan payment?",
            header: "Cancel Payment?",
            alertType: "confirm",
            inputLabel: "Reason",
            onConfirm: (reason) => {
                handleLoanCancellation(reason, rowData); // Pass rowData directly
            },
        }));
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearch = () => {
        console.log("handleSearch===========",searchText);
        console.log("handleSearch===========",allLoans);
        if (!searchText.trim()) {
            setLoanList(allLoans); // Reset to original data if search is cleared
            return;
        }
    
        const filteredLoans = allLoans.filter((row) => {
            return (
                row?.loanapplied?.loanid?.toLowerCase().includes(searchText.toLowerCase()) ||
                row?.loanapplied?.applyid?.toLowerCase().includes(searchText.toLowerCase()) ||
                row?.loanapplied?.amountapplied?.toString().includes(searchText) ||
                row?.loanapplied?.currcode?.toLowerCase().includes(searchText.toLowerCase()) ||
                row?.loanapplied?.paymentid?.toLowerCase().includes(searchText.toLowerCase()) ||
                row?.loanapplied?.totalamountapplied?.toLowerCase().includes(searchText.toLowerCase())
            );
        });
    
        setLoanList(filteredLoans);
    }

    // const handlePaymentBreakdown = async(loan) => {
    //     console.log("handlePaymentBreakdown-------------",loan)
    //     try {
    //         setSelectedLoan(loan)
    //         const response = await commonRunQuery(236, loan?.loanpayments?.paymentid);
    //         if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                
    //             const loanPaymentsArray = Array.isArray(response?.data?.body?.record)
    //             ? response?.data?.body?.record
    //             : [response?.data?.body?.record];
    //             console.log("loanPaymentsArray=======================",loanPaymentsArray);
                
    //         } else if(response?.data?.header?.reccount === "0") {
    //             setLoanList([]);
    //             setAllLoans([]);
    //         }
    //     } catch (error) {
    //         console.log("getPaymentsList_error=======================",error);
    //     }

    //     setOpenLoanDetailsDrawer(true);
    // }

    const handleMenuOpen = (event, loan) => {
        console.log("handleMenuOpen------------",loan)
        setAnchorEl(event.currentTarget);
        setSelectedLoan(loan);
    };

    const handleMenuClose = () => {
        console.log("handleMenuClose------------")
        setAnchorEl(null);
        // setSelectedLoan(null);
    };

    const handleViewDetails = (loan) => {
        setSelectedLoan(loan);
        // setOpenDetailsDialog(true);
        setOpenDetailsDrawer(true);
        handleMenuClose(); // close the menu
    };

    const formatAmount = (val) => val ? Number(val).toLocaleString('en-US', { minimumFractionDigits: 2 }) : '-';

    return (
        <Box className="loan-assignment-container">
        <Box className="d-flex justify-content-between">
            <Typography
            sx={{
                fontFamily: "'Nunito'",
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: "21.4825px",
                color: "#3A3A3A",
            }}
            className=""
            >
                Cancel Loan Payments
            </Typography>
            <Box>
                <Button
                    className="fs-size-12 paiy-blue text-white"
                    variant="contained"
                    color="primary"
                    onClick={() => setViewCancelPayments(false)}
                >
                    Return
                </Button>
            </Box>
        </Box>

        <Box>
            <Box className="search-container">
            <TextField
                placeholder="Search by Product name, Requested amount, etc."
                value={searchText}
                onChange={handleInputChange}
                onKeyDown={(event) => {
                    if (event.key === "Enter") {
                        handleSearch(); 
                    }
                }}
                variant="standard"
                fullWidth
                InputProps={{
                    disableUnderline: true,
                    sx: {
                        borderRadius: "33px",
                        color: "#000",
                    },
                    endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={handleSearch} edge="end">
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                    ),
                }}
                sx={{
                    "& .MuiInputBase-root": {},
                    "& .MuiInputBase-input": {
                        fontSize: "14px",
                    },
                }}
            />
            </Box>
        </Box>

            <Box className="mt-4">
                <TableContainer className="view-cancel-payments-table-container">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>Loan Id</StyledTableCell>
                                <StyledTableCell>Apply Id</StyledTableCell>
                                <StyledTableCell>Amount Applied</StyledTableCell>
                                <StyledTableCell>Currency Code</StyledTableCell>
                                <StyledTableCell>Payment Id</StyledTableCell>
                                <StyledTableCell align="right">Total Amount Applied</StyledTableCell>
                                <StyledTableCell>Action</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {
                            loanList && loanList.length > 0 ? (
                                loanList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell align="center" className="">
                                            <div>{row?.loanapplied?.loanid}</div>
                                        </TableCell>
                                        <TableCell align="center" className="">
                                            <div>{row?.loanapplied?.applyid}</div>
                                        </TableCell>
                                        <TableCell align="right" className="">
                                            <div>{Number(row?.loanapplied?.amountapplied).toLocaleString("en-US", { minimumFractionDigits: 2 })}</div>
                                        </TableCell>
                                        <TableCell align="center" className="">
                                            <div>{row?.loanapplied?.currcode}</div>
                                        </TableCell>
                                        <TableCell align="center" className="">
                                            <div>{row?.loanapplied?.paymentid}</div>
                                        </TableCell>
                                        <TableCell align="right" className="">
                                            <div>{Number(row?.loanapplied?.totalamountapplied).toLocaleString("en-US", { minimumFractionDigits: 2 })}</div>
                                        </TableCell>
                                        <TableCell>
                                            <IconButton onClick={(e) => handleMenuOpen(e, row)}>
                                                <MoreVertIcon />
                                            </IconButton>
                                        </TableCell>
                                        {/* <TableCell align="center" className="">
                                            <Button
                                                onClick={() => cancelLoanConfirmation(row)}
                                                variant="contained"
                                                size="small"
                                            >
                                                Cancel Payment
                                            </Button>
                                        </TableCell> */}
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell align="center" colSpan={7}>
                                        <Typography variant="body1" color="textSecondary">
                                        No data available
                                        </Typography>
                                    </TableCell>
                                    </TableRow>
                                )}
                        </TableBody>
                    </Table>
                </TableContainer>
               
                <TablePagination
                    rowsPerPageOptions={[5, 10, 20]}
                    component="div"
                    count={loanList.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />

                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                    <MenuItem
                        disabled={selectedLoan?.outstandingamountwithlatefee <= 0}
                        onClick={() => {
                            cancelLoanConfirmation(selectedLoan)
                            handleMenuClose();
                        }}
                    >
                        Cancel Payment
                    </MenuItem>
                    <MenuItem
                        disabled={selectedLoan?.outstandingamountwithlatefee <= 0}
                        onClick={() => {
                            handleViewDetails(selectedLoan)
                            handleMenuClose();
                        }}
                    >
                        View Details
                    </MenuItem>
                </Menu>
            </Box>

            <CustomInputAlert
                show={showInputAlert?.showAlert}
                severity={showInputAlert?.severity}
                header={showInputAlert?.header}
                message={showInputAlert?.message}
                alertType={showInputAlert?.alertType}
                inputLabel={showInputAlert?.inputLabel}
                confirmButton={(value) => showInputAlert?.onConfirm(value)} 
                // confirmButton={(value) => handleLoanApproval(value)} 
                onClick={() => setShowInputAlert(false)}
            />

            <BaseDrawer
                open={openLoanDetailsDrawer}
                handleClose={() => setOpenLoanDetailsDrawer(false)}
                height="85vh"
            >
                <LoanPaymentBreakdown selectedLoan={selectedLoan} />
            </BaseDrawer>

            <div className="loans-details-info-drawer">
                <BaseDrawer
                    open={openDetailsDrawer}
                    handleClose={() => setOpenDetailsDrawer(false)}
                    height="85vh"
                    className="loanProductInfoDrawer"
                    overflow="auto"
                >
                    {selectedLoan && (
                        <Box>
                            <Box className="user-accounts-tab">
                                <Box className="balance-container">
                                    <Box className="row" display="flex" flexWrap="wrap" gap={4}>

                                    {/* Left Column - General Info */}
                                    <Box minWidth="300px" flex={1}>
                                        <Typography
                                        sx={{
                                            fontWeight: 800,
                                            color: '#6b7280',
                                            fontFamily: 'Nunito',
                                            fontSize: '16px',
                                        }}
                                        >
                                        General Info
                                        </Typography>

                                        {[
                                        { label: 'Apply ID', value: selectedLoan?.loanapplied?.applyid },
                                        { label: 'User ID', value: selectedLoan?.loanapplied?.userid },
                                        { label: 'Loan ID', value: selectedLoan?.loanapplied?.loanid },
                                        { label: 'Payment ID', value: selectedLoan?.loanapplied?.paymentid },
                                        { label: 'Currency', value: selectedLoan?.loanapplied?.currcode },
                                        { label: 'Payment Plan ID', value: selectedLoan?.loanapplied?.paymentplanid },
                                        { label: 'Status', value: selectedLoan?.loanapplied?.status },
                                        { label: 'Confirmation Ref No', value: selectedLoan?.loanapplied?.confirmationrefno || '-' },
                                        { label: 'Confirmation Time', value: selectedLoan?.loanapplied?.confirmationtime || '-' },
                                        ].map(({ label, value }, i) => (
                                        <Box className="info-container" key={i} sx={{ display: 'flex', mb: 1 }}>
                                            <Box className="info-type" sx={{ fontWeight: 600, width: '50%' }}>
                                            {label}:
                                            </Box>
                                            <Box className="info-response" sx={{ width: '50%' }}>
                                            {value || '-'}
                                            </Box>
                                        </Box>
                                        ))}
                                    </Box>

                                    {/* Right Column - Payment Breakdown */}
                                    <Box minWidth="300px" flex={1}>
                                        <Typography
                                        sx={{
                                            fontWeight: 800,
                                            color: '#6b7280',
                                            fontFamily: 'Nunito',
                                            fontSize: '16px',
                                        }}
                                        >
                                        Payment Breakdown
                                        </Typography>

                                        {[
                                            { label: 'Amount Applied', value: formatAmount(selectedLoan?.loanapplied?.amountapplied) },
                                            { label: 'Fees Applied', value: formatAmount(selectedLoan?.loanapplied?.feesapplied) },
                                            { label: 'Total Amount Applied', value: formatAmount(selectedLoan?.loanapplied?.totalamountapplied) },
                                            { label: 'Tax Breakdown', value: formatAmount(selectedLoan?.loanapplied?.taxamountbreakdown) },
                                            { label: 'System Fee', value: formatAmount(selectedLoan?.loanapplied?.feesystembreakdown) },
                                            { label: 'External Fee', value: formatAmount(selectedLoan?.loanapplied?.feeexternalbreakdown) },
                                            { label: 'Franchisee Fee', value: formatAmount(selectedLoan?.loanapplied?.feefranchiseebreakdown) },
                                            { label: 'Reseller Fee', value: formatAmount(selectedLoan?.loanapplied?.feeresellerbreakdown) },
                                        ].map(({ label, value }, i) => (
                                        <Box className="info-container" key={i} sx={{ display: 'flex', mb: 1 }}>
                                            <Box className="info-type" sx={{ fontWeight: 600, width: '50%' }}>
                                            {label}:
                                            </Box>
                                            <Box className="info-response" sx={{ width: '50%' }}>
                                            {value}
                                            </Box>
                                        </Box>
                                        ))}
                                    </Box>

                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                </BaseDrawer>
            </div>
            
            <Dialog
                open={openDetailsDialog}
                onClose={() => setOpenDetailsDialog(false)}
                fullWidth
                maxWidth="md"
                className="loans-dialog"
            >
                <DialogTitle>
                    <Box>
                        Cancel Loan Payments Details
                        <Box sx={{ position: "absolute", top: 8, right: 8, width: 40, height: 40 }}>
                            <IconButton onClick={() => setOpenDetailsDialog(false)} sx={{ zIndex: 1, color: "#6c757d", "&:hover": { color: "#000" } }}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    {selectedLoan && (
                    <Box>
                        <Box className="user-accounts-tab">
                        <Box className="balance-container">
                            <Box className="row" display="flex" flexWrap="wrap" gap={4}>

                            {/* Left Column - General Info */}
                            <Box minWidth="300px" flex={1}>
                                <Typography
                                sx={{
                                    fontWeight: 800,
                                    color: '#6b7280',
                                    fontFamily: 'Nunito',
                                    fontSize: '16px',
                                }}
                                >
                                General Info
                                </Typography>

                                {[
                                { label: 'Apply ID', value: selectedLoan?.loanapplied?.applyid },
                                { label: 'User ID', value: selectedLoan?.loanapplied?.userid },
                                { label: 'Loan ID', value: selectedLoan?.loanapplied?.loanid },
                                { label: 'Payment ID', value: selectedLoan?.loanapplied?.paymentid },
                                { label: 'Currency', value: selectedLoan?.loanapplied?.currcode },
                                { label: 'Payment Plan ID', value: selectedLoan?.loanapplied?.paymentplanid },
                                { label: 'Status', value: selectedLoan?.loanapplied?.status },
                                { label: 'Confirmation Ref No', value: selectedLoan?.loanapplied?.confirmationrefno || '-' },
                                { label: 'Confirmation Time', value: selectedLoan?.loanapplied?.confirmationtime || '-' },
                                ].map(({ label, value }, i) => (
                                <Box className="info-container" key={i} sx={{ display: 'flex', mb: 1 }}>
                                    <Box className="info-type" sx={{ fontWeight: 600, width: '50%' }}>
                                    {label}:
                                    </Box>
                                    <Box className="info-response" sx={{ width: '50%' }}>
                                    {value || '-'}
                                    </Box>
                                </Box>
                                ))}
                            </Box>

                            {/* Right Column - Payment Breakdown */}
                            <Box minWidth="300px" flex={1}>
                                <Typography
                                sx={{
                                    fontWeight: 800,
                                    color: '#6b7280',
                                    fontFamily: 'Nunito',
                                    fontSize: '16px',
                                }}
                                >
                                Payment Breakdown
                                </Typography>

                                {[
                                { label: 'Amount Applied', value: formatAmount(selectedLoan?.loanapplied?.amountapplied) },
                                { label: 'Fees Applied', value: formatAmount(selectedLoan?.loanapplied?.feesapplied) },
                                { label: 'Total Amount Applied', value: formatAmount(selectedLoan?.loanapplied?.totalamountapplied) },
                                { label: 'Tax Breakdown', value: formatAmount(selectedLoan?.loanapplied?.taxamountbreakdown) },
                                { label: 'System Fee', value: formatAmount(selectedLoan?.loanapplied?.feesystembreakdown) },
                                { label: 'External Fee', value: formatAmount(selectedLoan?.loanapplied?.feeexternalbreakdown) },
                                { label: 'Franchisee Fee', value: formatAmount(selectedLoan?.loanapplied?.feefranchiseebreakdown) },
                                { label: 'Reseller Fee', value: formatAmount(selectedLoan?.loanapplied?.feeresellerbreakdown) },
                                ].map(({ label, value }, i) => (
                                <Box className="info-container" key={i} sx={{ display: 'flex', mb: 1 }}>
                                    <Box className="info-type" sx={{ fontWeight: 600, width: '50%' }}>
                                    {label}:
                                    </Box>
                                    <Box className="info-response" sx={{ width: '50%' }}>
                                    {value}
                                    </Box>
                                </Box>
                                ))}
                            </Box>

                            </Box>
                        </Box>
                        </Box>
                    </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDetailsDialog(false)} color="primary">
                    Close
                    </Button>
                </DialogActions>
                </Dialog>
        </Box>
    );
};

export default LoanPaymentViewCancel;
